/* @flow */
export function roundNumber(price: number, precision: number = 100): number {
    return Math.round(price * precision) / precision;
}

export function normalizeAmount(amount: number | undefined | null, optPositive?: boolean): number {
    return Math.min(99999, Math.abs(amount || (optPositive ? 1 : 0)));
}
